<template>
    <div v-if="talkgroupAttribute != null">
        <el-tabs v-if="showTab" v-model="selectedTabName" type="border-card" @tab-click="handleChangeTab" :before-leave="beforeLeave">
            <el-tab-pane :label="$t('message.title_group_information')" name="groupInfo"></el-tab-pane>
            <el-tab-pane :label="$t('message.title_groupUser')" name="userGroup"></el-tab-pane>
            <el-tab-pane v-if="talkgroupAttribute.talkgroupOptions.subGroup" :label="$t('message.item_option_subGroup')" name="subGroup"></el-tab-pane>
            <el-tab-pane v-if="getNumberOfAppsWithoutStorage() > 0" :label="$t('message.title_groupAi')" name="aiGroup"></el-tab-pane>
            <!-- ############################################ -->
            <!-- Group Information                            -->
            <!-- ############################################ -->
            <div v-if="selectedTabName=='groupInfo'">
                <div class="object-titlebox">
                    <div class="object-titlebox-right">
                        <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('DeleteGroup')"><img src="../assets/delete.svg"/><span class="important-command-text" v-t="'message.common_action_delete'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('MoveGroup')"><img src="../assets/move.svg"/><span class="normal-command-text" v-t="'message.common_action_move'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditGroup')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                    </div>
                </div>
                <table width=100%>
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_groupId'"></td>
                        <td class="object-value">{{ talkgroupAttribute.name }}</td>
                    </tr>
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_groupDisplayName'"></td>
                        <td class="object-value">{{ talkgroupAttribute.displayName }}</td>
                    </tr>
                    <!---tr class="objectitem-record">
                        <td width=50% class="object-item">リージョン</td>
                        <td class="object-value">{{ talkgroupAttribute.region }}</td>
                    </tr--->
                    <!---- 音声データの保存 ---->
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_save_voice'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.saveVoice" class="object-value" v-t="'message.item_save'"></td>
                        <td v-else class="object-value" v-t="'message.item_no_save'"></td>
                    </tr>
                    <!---- データの保存先 ---->
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_data_storage'"></td>
                        <td v-if="targetStorage == null" class="object-value" v-t="'message.item_default'"></td>
                        <td v-else class="object-value" v-t="targetStorage.displayName"></td>
                    </tr>
                    <!---- 通話自動終了 ---->
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_talk_timer'"></td>
                        <td class="object-value">{{ talkgroupAttribute.durationLimit }}</td>
                    </tr>
                    <!---- 通話方式 ---->
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_talk_type'"></td>
                        <td class="object-value" v-t="getTalkTypeName"></td>
                    </tr>
                    <!---- かんたんログイン ---->
                    <tr class="objectitem-record">
                        <td width=50% class="object-item">
                            <div v-t="'message.item_option_easyLogin'"></div>
                            <div v-if="needEasyLoginSelectionWarning" style="font-size:10px; font-weight:bold; color:#d55169" v-html="$t('message.info_easy_login_need_client_version')"></div>
                        </td>
                        <td v-if="talkgroupAttribute.easyLoginURL != null" class="object-value">
                            <span v-t="getEasyLoginTitle"></span>
                            <el-tooltip effect="dark" placement="top-start">
                                <div slot="content" style="text-align:left" v-html="getEasyLoginHint"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                            <div>
                                <button class="transparent-button" type="button" @click="showQrEasyLogin=true"><i class="el-icon-full-screen"></i><span class="normal-command-text" style="margin-left:5px" v-t="'message.item_show_url_qr_code'"></span></button>
                            </div>
                        </td>
                        <td v-else class="object-value"><span v-t="'message.item_value_nonUsed'"></span></td>
                    </tr>
                    <!---- 低ビットレートモード ---->
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_option_lowBitRate'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.lowBitRate" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <!---- 位置情報 ---->
                    <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_option_location_information'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.location" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <!---- マップ通話 ---->
                    <tr v-if="isVisibleGroupOption('mapTalk')" class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_option_map_talk'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.mapTalk" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <!---- サブグループ ---->
                    <tr v-if="appData.enableSubgroupOption" class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_option_subGroup'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.subGroup" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <!---- E2E Encryption ---->
                    <tr v-if="appData.enableE2EEncryptionOption" class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_e2e_encryption'"></td>
                        <template v-if="talkgroupAttribute.talkgroupOptions.e2eEncryption">
                            <td width=20% class="object-value" v-t="'message.item_value_used'"></td>
                            <td>
                                <button class='transparent-button' type="button" @click='showE2EPasswordInput=true'><span class="normal-command-text" v-t="'message.item_new_password'"/></button>
                            </td>
                        </template>
                        <template v-else>
                            <td class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </template>
                    </tr>
                    <!---- 音声テキスト化 ---->
                    <tr v-if="showOptionSetting" class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_option_speechToText'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.speechToTextEngine > 0" class="object-value" v-t="{ path: 'message.item_value_used_with_engine', args: { engine: getSpeechToTextEngineName(talkgroupAttribute.talkgroupOptions.speechToTextEngine) } }"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <!---- 翻訳 ---->
                    <tr v-if="showOptionSetting" class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_option_translation'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.translationEngine > 0" class="object-value" v-t="{ path: 'message.item_value_used_with_engine', args: { engine: getTranslationEngineName(talkgroupAttribute.talkgroupOptions.translationEngine) } }"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <template v-if="isVisibleGroupOption('video')">
                        <!---- ライブキャスト ---->
                        <tr v-if="isVisibleGroupOption('video')" class="objectitem-record">
                            <td width=50% class="object-item" v-t="'message.item_option_video'"></td>
                            <td v-if="talkgroupAttribute.talkgroupOptions.video" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <!---- ライブキャストの保存 ---->
                        <tr v-if="talkgroupAttribute.talkgroupOptions.video" class="objectitem-record">
                            <td width=50% class="object-item" v-t="'message.item_save_livecast'"></td>
                            <td v-if="talkgroupAttribute.talkgroupOptions.saveLivecast" class="object-value" v-t="'message.item_save'"></td>
                            <td v-else class="object-value" v-t="'message.item_no_save'"></td>
                        </tr>
                        <!---- ライブキャスト自動終了 ---->
                        <tr v-if="talkgroupAttribute.talkgroupOptions.video" class="objectitem-record">
                            <td width=50% class="object-item" v-t="'message.item_video_timer'"></td>
                            <td class="object-value">{{ talkgroupAttribute.videoDurationLimit }}</td>
                        </tr>
                    </template>
                    <!---- 切断検知グループ ---->
                        <tr class="objectitem-record">
                        <td width=50% class="object-item" v-t="'message.item_option_alertMode'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.disconnectAlert" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                    </tr>
                    <!---- tr class="objectitem-record">
                        <td width=50% class="object-item">オブジェクトID</td>
                        <td class="object-value">{{ talkgroupAttribute.id }}</td>
                    </tr ----->
                </table>
            </div>
            <!-- ############################################ -->
            <!-- User Assignment                              -->
            <!-- ############################################ -->
            <div v-else-if="selectedTabName=='userGroup'">
                <div class="object-titlebox">
                    <div class="object-titlebox-left" v-t="{ path: 'message.title_userOfGroup', args: { name: talkgroupAttribute.displayName, userCount: userCount} }"></div>
                    <div class="object-titlebox-right">
                        <div v-if="talkgroupUsers.length==0">
                            <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('AddUserToGroup')"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_user_to_group'"></span></a>
                        </div>
                        <div v-else>
                            <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('AddUserToGroup')"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_user_of_group'"></span></a>
                        </div>
                   </div>
                </div>
                <div class="object-titlebox">
                    <div class="object-titlebox-text">
                        <table>
                            <tr>
                                <td style="padding-left:20px;">
                                    <el-tooltip effect="dark" placement="right" >
                                        <div v-if="isMandatorySwitchDisable()" slot="content" style="text-align:left" v-t="showErrorInfo"><br></div>
                                        <div v-else slot="content" style="text-align:left" v-html="$t('message.hint_mandatory')">
                                        </div>
                                        <span><span v-t="'message.action_mandatory'"></span><el-switch v-model="mandatoryFlag" style="padding-left:10px" @change="handleChangeMandatoryOfGroup()" active-color="#5171cb" :disabled="isMandatorySwitchDisable()"></el-switch></span>
                                    </el-tooltip>
                                </td>
                            </tr>
                            <tr v-if="(loadingScreen == null) && mandatoryFlag && (userCount!=mandatoryUserCount)">
                                <td class="error-message-text" v-t="'message.error_non_mandatory_user_exist'">
                                </td>
                            </tr>
                            <tr>
                                <td style="padding-left:20px;padding-top:10px">
                                    <el-form @submit.native.prevent="submit">
                                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" class="object-search-select" style="width:540px;" clearable  @clear="getUserTalkgroupInfo(null)" :disabled="userSearchDisabled" >
                                            <el-select class="search-item" v-model="condition" slot="prepend" @change="handleChangeSearchCondition()">
                                                <el-option :label="$t('message.item_display_all')" value="all"></el-option>
                                                <el-option :label="$t('message.item_userId')" value="name"></el-option>
                                                <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                                <el-option :label="$t('message.item_organization')" value="organization"></el-option>
                                                <el-option :label="$t('message.item_job_title')" value="title"></el-option>
                                                <el-option :label="$t('message.item_mandatory_yes')" value="mandatoryYes"></el-option>
                                                <el-option :label="$t('message.item_mandatory_no')" value="mandatoryNo"></el-option>
                                            </el-select>
                                            <el-button slot="append" @click="findUser()" class="search-button" native-type="submit" v-t="'message.action_filter_items'"></el-button>
                                        </el-input>
                                    </el-form>
                                </td>
                            </tr>
                            <tr v-if="talkgroupUsersExceededMax">
                                <td class="error-message-text"  v-t="{ path: 'message.info_exceeds_user_count', args: { name: talkgroupUsers.length } }">
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <!--div v-if="talkgroupUsersExceededMax" class="object-titlebox">
                    <div class="object-titlebox-left" style="color:#d55169;" v-t="{ path: 'message.info_exceeds_user_count', args: { count: talkgroupUsers.length } }"></div>
                </div-->
                <table width=100%>
                    <tr class="talkgroup-user-title">
                        <td class="talkgroup-user-header1" v-t="'message.item_userId_displayName'"></td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.subGroup" class="talkgroup-user-header1" v-t="'message.title_joined_sub_group'"></td>
                        <td class="talkgroup-user-header2" v-t="'message.item_mandatory'"></td>
                        <td class="talkgroup-user-header2" v-t="'message.common_action_delete'"></td>
                    </tr>
                    <tr class="talkgroup-user-record" v-for="(talkgroupUser,index) in talkgroupUsers">
                        <td class="object-item">
                            {{ talkgroupUser.userName + "@" + talkgroupUser.userTenantName + " / " + talkgroupUser.displayName }}<span class="defaulttalkgroup" v-show="talkgroupUser.defaultFlag == 1">(デフォルト)</span>
                        </td>
                        <td v-if="talkgroupAttribute.talkgroupOptions.subGroup" class="object-item">
                            {{ getJoinedSubGroupName(talkgroupUser) }}
                        </td>
                        <td class="object-item2">
                            <label>
                                <input type="hidden" name="mandatory" :value="talkgroupUser.mandatoryFlag" />
                                <input class="custom-checkbox-input" name="mandatory" value="True" type="checkbox">
                                <span v-if="talkgroupUser.mandatoryFlag">
                                    <img class="action-icon" src="../assets/icon_check_green.svg" @click="handleChangeMandatory(talkgroupUser)"/>
                                </span>
                                <span v-else>
                                    <img class="action-icon" src="../assets/icon_check_gray.svg" @click="handleChangeMandatory(talkgroupUser)"/>
                                </span>
                            </label>
                        </td>
                        <td class="object-item2">
                            <button class="item-record-button" type="button" v-on:click="removeTalkgroupUser(index)"><img class="icon-delete" src="../assets/icon_delete_user.svg"/></button>
                        </td>
                        <!--td class="object-item">
                        <div class="object-userlist-left">
                            <div class="object-userlist-right">
                                <button class="item-record-button" type="button" v-on:click="removeTalkgroupUser(index)"><img class="icon-delete" src="../assets/icon_delete_user.svg"/></button>
                            </div>
                            {{ talkgroupUser.userName + "@" + talkgroupUser.userTenantName + " / " + talkgroupUser.displayName }}<span class="defaulttalkgroup" v-show="talkgroupUser.defaultFlag == 1">(デフォルト)</span>
                        </div>
                        </td--->
                    </tr>
                </table>
            </div>
            <div v-else-if="selectedTabName=='subGroup'">
                <table width="100%">
                    <tr class="talkgroup-user-title">
                        <td class="talkgroup-user-header1" width="5%">ID</td>
                        <td class="talkgroup-user-header1" width="20%" v-t="'message.title_sub_group_name'"></td>
                        <td class="talkgroup-user-header1" style="padding-top:5px;padding-bottom:5px">
                            <el-select v-model="subGroupInfoType" style="width:130px;padding-right:15px" @change="">
                                <div v-for="subGroupInfo in subGroupInfoList">
                                    <el-option style="font-size:12px" :label="subGroupInfo.label" :value="subGroupInfo.value"></el-option>
                                </div>
                            </el-select>
                        </td>
                        <td class="talkgroup-user-header2"  width="20%" v-t="'message.common_action_edit'"></td>
                    </tr>
                    <tr v-for="subGroup in talkgroupAttribute.subGroups" class="objectitem-record">
                        <td class="object-item">{{ subGroup.subGroupId }}</td>
                        <td class="object-item">{{ subGroup.displayName }}</td>
                        <td v-if="subGroupInfoType == Const.SUB_GROUP_INFO_DESTINATIONS" class="object-item">{{ getTargetSubGroupName(subGroup) }}</td>
                        <td v-else class="object-item">{{ getUsersOfTargetSubGroup(subGroup) }}</td>
                        <td class="object-item" style="width:8%;padding-left:0px">
                            <button class="item-record-button" type="button" v-on:click="showEditSubGroupDialog(subGroup)"><img class="icon-delete" src="../assets/edit.svg"/></button>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- ############################################ -->
            <!-- AI/App Assignment                                -->
            <!-- ############################################ -->
            <div v-else-if="selectedTabName=='aiGroup'">
                <div class="object-titlebox">
                    <div class="object-titlebox-left" v-t="{ path: 'message.title_aiOfGroup', args: { name: talkgroupAttribute.displayName} }"></div>
                    <div class="object-titlebox-right">
                        <div v-if="processorDefinitionIdsWithoutStorage.length == 0">
                            <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('AddAiToGroup')">
                                <img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_ai_to_group'"></span>
                            </button>
                        </div>
                        <div v-else>
                            <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('AddAiToGroup')">
                                <img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_ai_of_group'"></span>
                            </button>
                        </div>
                   </div>
                </div>
                <table width=100%>
                    <tr class="talkgroup-user-title">
                        <td class="talkgroup-user-header1" v-t="'message.item_aiDisplayName'"></td>
                        <td class="talkgroup-user-header2" v-t="'message.common_action_delete'"></td>
                    </tr>
                    <tr class="talkgroup-user-record" v-for="processorDefinitionId in processorDefinitionIdsWithoutStorage">
                        <td class="object-item">
                            {{ getProcessorDefinitionById(processorDefinitionId).displayName }}
                        </td>
                        <td class="object-item2">
                            <button class="item-record-button" type="button" v-on:click="confirmRemoveAiAssignment(processorDefinitionId)"><img class="icon-delete" src="../assets/icon_delete_user.svg"/></button>
                        </td>
                    </tr>
                </table>
            </div>
        </el-tabs>
        <addusertotalkgroup v-if="showUserTalkgroup" :appData="appData" :talkgroupAttribute="talkgroupAttribute" :addUser="talkgroupUsers.length==0" @update="updateTalkgroupUsersAfterDisappearDialog" @cancel="showUserTalkgroup=false"></addusertotalkgroup>
        <deletetalkgroup v-if="showDeleteTalkgroup" :confirmInfo="confirmInfo" @delete="deleteTalkgroup" @cancel="showDeleteTalkgroup=false"></deletetalkgroup>
        <movetalkgroup v-if="showMoveTalkgroup" :appData="appData" @move="moveTalkgroup" :sourceObjectId="talkgroupAttribute.id" @cancel="showMoveTalkgroup=false"></movetalkgroup>
        <edittalkgroup v-if="showEditTalkgroup" :appData="appData" :talkgroupAttribute="talkgroupAttribute" :talkgroupUserCount="talkgroupUsers.length" :targetStorage="targetStorage" @save="modifyTalkgroup" @showManual="showManual()" @cancel="showEditTalkgroup=false"></edittalkgroup>
        <edit-sub-group v-if="showEditSubGroup" :appData="appData" :talkGroupAttribute="talkgroupAttribute" :talkgroupUsers="talkgroupUsers" :subGroup="targetSubGroup" :subGroupInfoType="subGroupInfoType" @save="modifySubGroup" @cancel="showEditSubGroup=false"></edit-sub-group>
        <confirmdeleteuser v-if="showConfirmDeleteUser" :confirmInfo="confirmInfo" @delete="removeFromTalkgroup" @cancel="showConfirmDeleteUser=false"></confirmdeleteuser>
        <confirmdeleteai v-if="showConfirmDeleteAi" :confirmInfo="confirmInfo" @delete="removeAiAssignment" @cancel="showConfirmDeleteAi=false"></confirmdeleteai>
        <addProcessorDefinitionToTalkgroup v-if="showAiTalkgroup" :appData="appData" :talkgroupAttribute="talkgroupAttribute" :addAi="processorDefinitionIdsWithoutStorage.length == 0" @update="updateTalkgroupAi" @cancel="showAiTalkgroup=false"></addProcessorDefinitionToTalkgroup>
        <password-input-modal v-if="showE2EPasswordInput" :title="$t('message.item_e2e_encryption_setting')" :label="$t('message.item_new_password')" @onSave="setE2EEncryptionPassword" @onCancel="showE2EPasswordInput=false"></password-input-modal>
        <qrEasyLogin v-if="showQrEasyLogin" :appData="appData" :talkgroupAttribute="talkgroupAttribute" @cancel="showQrEasyLogin=false" ></qrEasyLogin>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import AddUserToTalkgroup from "./AddUserToTalkgroup.vue";
import AddProcessorDefinitionToTalkgroup from "./AddProcessorDefinitionToTalkgroup.vue";
import DeleteObject from "./DeleteObject.vue";
import EditTalkgroup from "./EditTalkgroup.vue";
import EditSubGroup from "./EditSubGroup.vue";
import MoveTalkgroup from "./MoveObject.vue";
import PasswordInputModal from './PasswordInputModal.vue';
import commonUtil from './commonutil.js';
import constants from './constants.js';
import { Loading } from 'element-ui';
import QrEasyLogin from './QrEasyLogin.vue';

export default {
    components: {
        deletetalkgroup: DeleteObject,
        movetalkgroup: MoveTalkgroup,
        edittalkgroup: EditTalkgroup,
        addusertotalkgroup: AddUserToTalkgroup,
        confirmdeleteuser: DeleteObject,
        confirmdeleteai: DeleteObject,
        EditSubGroup,
        addProcessorDefinitionToTalkgroup: AddProcessorDefinitionToTalkgroup,
        PasswordInputModal,
        qrEasyLogin: QrEasyLogin,
    },
    data() {
      return {
        Const: {
            SUB_GROUP_INFO_DESTINATIONS: 1,
            SUB_GROUP_INFO_USERS: 2,
        },
        mandatoryFlag: false,
        showDeleteTalkgroup: false,
        showMoveTalkgroup: false,
        showEditTalkgroup: false,
        showEditSubGroup: false,
        showE2EPasswordInput: false,
        showUserTalkgroup: false,
        showConfirmDeleteUser: false,
        showConfirmDeleteAi: false,
        showAiTalkgroup: false,
        showTab: true,
        showQrEasyLogin: false,
        talkgroupAttribute: null,
        talkgroupUsers: [],
        confirmInfo: {
            objectName: null,
            objectTitle: null
        },
        removeUserIndex: null,
        removeProcessorDefinitionId: null,
        talkgroupUsersExceededMax: false,
        userSearchDisabled: false,
        condition: "all",
        searchString: null,
        userCount: 0,
        mandatoryUserCount: 0,
        loadingScreen: null,
        selectedTabName: null,
        targetSubGroup: null,
        subGroupInfoType: null,
        subGroupInfoList: [],
        joinedUsersOfSubGroup: {},
        targetStorage: null,
        processorDefinitionIdsWithoutStorage: [],
      };
    },
    methods: {
        getInfo: function() {
            if (this.selectedNode == null) {
                return;
            }
            let self = this;
            this.searchString = null;
            this.$data.talkgroupUsersExceededMax = false;
            this.$data.userSearchDisabled = false;

            this.showLoadingScreen();

            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: this.selectedNode.node.data.id })
                .then((res) => {
                    self.closeLoadingScreen();
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (self.selectedNode.node.parent.data.id != res.data.pid) {
                                self.nodeInfo = null;
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_moved").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                                self.$emit('refresh');
                                return;
                            }
                            if (res.data.users.length == 0) {
                                this.$data.userSearchDisabled = true;
                            } else {
                                this.$data.userSearchDisabled = false;
                            }
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            self.talkgroupUsersCount = res.data.users.length
                            self.talkgroupUsersExceededMax = true;
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_read_permission_on_layer").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                            self.$emit('refresh');
                            return;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            self.$emit('resetSelectedNode');
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                            self.$emit('refresh');
                            return;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                            return
                    }
                    self.talkgroupAttribute = res.data;
                    self.mandatoryFlag = self.talkgroupAttribute.talkgroupOptions.mandatory;
                    self.targetStorage = null;
                    self.processorDefinitionIdsWithoutStorage = [];
                    for (let processorDefinitionId of res.data.processorDefinitionIds) {
                        let foundDefinition = null;
                        for (let processorDefinition of self.$root.store.processorDefinitionList) {
                            if (processorDefinition.id == processorDefinitionId) {
                                foundDefinition = processorDefinition;
                                break;
                            }
                        }
                        if (foundDefinition != null) {
                            if (foundDefinition.serviceId == constants.VAULT_SERVICE_STORAGE) {
                                self.targetStorage = foundDefinition;
                            } else {
                                self.processorDefinitionIdsWithoutStorage.push(foundDefinition.id);
                            }
                        }
                    }
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                });
        },
        getUserTalkgroupInfo(message) {
            this.showLoadingScreen();
            let self = this;
            self.condition = "all";
            self.searchString = null;
            self.userCount = 0
            self.mandatoryUserCount = 0
            self.talkgroupUsers =[];
            self.userList = {}
            server.post('/getusertalkgroupinfo', { talkgroupTenantId: this.appData.tenantList[0].tenantId, id: this.talkgroupAttribute.id })
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            if (res.data.status == constants.STATUS_SUCCESS) {
                                self.talkgroupUsersExceededMax = false;
                            } else {
                                self.talkgroupUsersExceededMax = true;
                            }
                            self.setJoinedUsersOfSubGroup(res.data.userTalkgroup)
                            self.userCount = res.data.userCount;
                            self.mandatoryUserCount = res.data.mandatoryUserCount;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserTalkgroupInfo").replace("{code}",res.data.status));
                            self.closeLoadingScreen();
                            return;
                    }
                    self.talkgroupUsers = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_USER).sortedUserTalkGroup;
                    self.closeLoadingScreen();
                    if (message != null) {
                        // need to set more delay time to show the message after close loading screen.
                        commonUtil.notifyMessageWithDuration(self, message.type, message.text, 2000);
                    }
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getUserTalkgroupInfo", error);
                });
        },
        getConnectedTenantList() {
            let self = this;
            server.post('/gettenantconnectinfo',{type: 0})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.appData.importedTenantList = res.data.importTenantList;
                            self.appData.exportedTenantList = res.data.exportTenantList;
                            self.getInfo();
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getConnectedTenantList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTenantConnectInfo", error);
                });
        },
        showEditSubGroupDialog(subGroup) {
            this.targetSubGroup = subGroup;
            this.showDialogAfterWritableCheck("EditSubGroup");
        },
        showDialogAfterWritableCheck(functionName) {
            if (functionName == "DeleteGroup") {
                if (this.talkgroupAttribute.id == this.appData.tenantList[0].samlGroup) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_saml_group"));
                    return;
                }
            }
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            let self = this;
            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: this.selectedNode.node.parent.data.id })
                .then((res) => {
                    if(res.data.status == constants.STATUS_SUCCESS) {
                        let myAclId = self.appData.tenantList[0].tenantId + "-" + self.appData.loginUserObjectId;
                        let acl = JSON.parse(res.data.acl)
                        if (acl.rw != null) {
                            let writable = acl.rw.find(function(element) {
                                return element == myAclId;
                            });
                            if (writable == null) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                            } else {
                                switch(functionName) {
                                    case "AddUserToGroup":
                                        self.showUserTalkgroup = true;
                                        break;
                                    case "EditGroup":
                                        self.showEditTalkgroup = true;
                                        break;
                                    case "DeleteGroup":
                                        self.deleteConfirmTalkgroup();
                                        break;
                                    case "MoveGroup":
                                        self.showMoveTalkgroup = true;
                                        break;
                                    case "EditSubGroup":
                                        self.showEditSubGroup = true;
                                        break;
                                    case "AddAiToGroup":
                                        self.showAiTalkgroup = true;
                                        break;
                                }
                            }
                        } else {
                            // no writable acl info
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                        }
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","showDialogAfterWritableCheck").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "showDialogAfterWritableCheck", error);
                });
        },
        modifyTalkgroup: function(input) {
            this.$data.showEditTalkgroup = false;
            let operationParam = {id: this.talkgroupAttribute.id}
            let changeAttribute = false;
            if (input.name != this.talkgroupAttribute.name) {
                changeAttribute = true;
                operationParam.newName = input.name;
            }
            if (input.displayName != this.talkgroupAttribute.displayName) {
                changeAttribute = true;
                operationParam.newDisplayName = input.displayName;
            }
            if (input.durationLimit != this.talkgroupAttribute.durationLimit) {
                changeAttribute = true;
                operationParam.newDurationLimit = input.durationLimit;
            }
            if (input.videoDurationLimit != this.talkgroupAttribute.videoDurationLimit) {
                changeAttribute = true;
                operationParam.newVideoDurationLimit = input.videoDurationLimit;
            }
            if (input.talkGroupOptions != null) {
                changeAttribute = true;
                operationParam.newTalkgroupOptions = input.talkGroupOptions;
            }
            if (input.processorDefinitionIds != null) {
                changeAttribute = true;
                operationParam.newProcessorDefinitionIds = input.processorDefinitionIds;
            }
            if (input.removeProcessorDefinitionIds != null) {
                changeAttribute = true;
                operationParam.removeProcessorDefinitionIds = input.removeProcessorDefinitionIds;
            }

            if (!changeAttribute) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                return;
            }
            let self = this;
            server.post(
                '/modifytalkgroup',
                {
                    operation: operationParam
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_group"));
                    if (this.listType == 0) {
                        if (self.selectedNode.node.data.label != input.name) {
                            var insertData = { data :
                                                {
                                                    tenantId: self.selectedNode.node.data.tenantId,
                                                    id: self.selectedNode.node.data.id,
                                                    label: input.name,
                                                    type: 2,
                                                    isLeaf: true
                                                 }
                                             };
                            this.insertNewTalkgroupToTree(insertData, self.selectedNode.node.parent);
                            self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                        }
                    } else {
                        self.$emit('refresh');
                    }
                    self.getInfo();
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                            break;
                        case constants.STATUS_ERROR_OPTION_UNMATCH:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_enable_groupOption"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_group_duplicate"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyTalkgroup").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyTalkgroup", error);
            });
        },
        modifySubGroup: function(operationParam) {
            this.showEditSubGroup = false;
            if (operationParam.length == 0) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                return;
            }
            let self = this;
            server.post(
                '/multiop',
                {
                    operations: operationParam
                }
            ).then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success","サブグループを更新しました。");
                        self.getInfo();
                        self.getUserTalkgroupInfo(null)
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifySubGroup").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifySubGroup", error);
            });
        },
        async setE2EEncryptionPassword(pass) {
            this.showE2EPasswordInput = false
            let hashedPass = await commonUtil.sha256(pass)

            let res;
            try {
                res = server.post('/setgroupe2eencryption', {talkgroupId: this.talkgroupAttribute.id, encryption : true, hashedPassword : hashedPass})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "setE2EEncryptionPassword", error);
            }

            switch(res.data.status) {
                case constants.STATUS_SUCCESS:
                    commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n,"info_e2e_encryption_changed"));
                    break;
                default:
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","setE2EEncryptionPassword").replace("{code}",res.data.status));
                    break;
            }

        },
        deleteConfirmTalkgroup: function() {
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"item_group");
            this.confirmInfo.objectName = this.talkgroupAttribute.name;
            this.showDeleteTalkgroup = true;
        },
        deleteTalkgroup: function() {
            this.$data.showDeleteTalkgroup = false;
            let self = this;
            server.post(
                '/deletetalkgroup',
                {
                    operation:
                    {
                        id: this.$data.talkgroupAttribute.id
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_group"));
                    if (this.listType == 0) {
                        self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                    } else {
                        self.$emit('refresh');
                    }
                    self.$emit('resetSelectedNode');
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_STILL_ASSIGNED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_group_exist_user"));
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                            break;
                        case constants.STATUS_ERROR_BELL_ASSIGNED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_group_bell_assigned"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","deleteTalkgroup").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "deleteTalkgroup", error);
            });
        },
        moveTalkgroup: function(destinationNodeId) {
            this.$data.showMoveTalkgroup = false;
            let self = this;
            server.post(
                '/move',
                {
                    operation:
                    {
                        id: this.$data.talkgroupAttribute.id ,
                        destinationId: destinationNodeId
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_moved_group"));
                    let parentNode = self.findNode(self.selectedNode.tree.$children[0].node , destinationNodeId);
                    if (parentNode != null) {
                        // parent node already loaded
                        var insertData = { data :
                                            {
                                                tenantId: self.selectedNode.node.data.tenantId,
                                                id: self.selectedNode.node.data.id,
                                                label: self.selectedNode.node.data.label,
                                                type: 2,
                                                isLeaf: true
                                             }
                                         };
                        this.insertNewTalkgroupToTree(insertData, parentNode);
                    }
                    self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","moveTalkgroup").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "moveTalkgroup", error);
            });
        },
        // confirm remove user from talkgroup
        removeTalkgroupUser: function(index) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            if (this.talkgroupUsers[index].userTenantId != this.appData.tenantList[0].tenantId) {
                if (!commonUtil.isTenantConnectAdmin(this.appData, this.talkgroupUsers[index].userTenantId)) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_user_of_other_tenant"));
                    return;
                }
            }
            this.removeUserIndex = index;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_groupUser");
            this.confirmInfo.objectName = this.talkgroupUsers[this.$data.removeUserIndex].displayName;
            this.showConfirmDeleteUser = true;
        },
        // remove user from talkgroup
        removeFromTalkgroup: function() {
            this.showConfirmDeleteUser = false;
            let self = this;
            let operations = [];
            let parameter;
            let commandName;
            let remoteUser = false;
            commandName = "/removefromtalkgroup";
            parameter = { operation:
                            {
                                tenantId: this.talkgroupUsers[this.removeUserIndex].tenantId ,
                                talkgroupId: this.talkgroupAttribute.id ,
                                userTenantId: this.talkgroupUsers[this.removeUserIndex].userTenantId ,
                                userId: this.talkgroupUsers[this.removeUserIndex].userId
                            }
                        };
            if (this.appData.tenantList[0].tenantId != this.talkgroupUsers[this.removeUserIndex].userTenantId) {
                remoteUser = true;
            }
            server.post(commandName, parameter)
            .then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    self.getUserTalkgroupInfo({type: "Success", text:commonUtil.getMessageText(self.$i18n,"info_deleted_userOfGroup")});
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_remove_user_default_group"));
                            break;
                        default:
                            if (remoteUser) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_remove_user_of_other_tenant"));
                            } else {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_remove_user_access_denied"));
                            }
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "removeFromTalkgroup", error);
            });
        },
        removeAiAssignment() {
            this.showConfirmDeleteAi = false;
            this.modifyTalkgroupAi(null, [this.removeProcessorDefinitionId]);
        },
        updateTalkgroupAi(newProcessorDefinitionIds, removeProcessorDefinitionIds) {
            this.showAiTalkgroup = false;
            this.modifyTalkgroupAi(newProcessorDefinitionIds, removeProcessorDefinitionIds);
        },
        modifyTalkgroupAi(newProcessorDefinitionIds, removeProcessorDefinitionIds) {
            let operationParam = {
                id: this.talkgroupAttribute.id,
                newProcessorDefinitionIds: newProcessorDefinitionIds,
                removeProcessorDefinitionIds: removeProcessorDefinitionIds,
            };
            let self = this;
            server.post('/modifytalkgroup', {operation: operationParam}
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_group"));
                        self.$emit('refresh');
                        this.getInfo();
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                        break;
                    case constants.STATUS_ERROR_OPTION_UNMATCH:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_enable_groupOption"));
                        break;
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_group")));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyTalkgroup").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyTalkgroup", error);
            });
        },
        updateTalkgroupUsersAfterDisappearDialog(input) {
            // dialog will not be disappeared immediately when a lot of users in the tenant
            // update talkGroup users after disappear(DOM element of dialog not found) the dialog
            this.showUserTalkgroup=false;
            let self = this;
            let timer = setInterval(
                function() {
                    if (document.getElementById("addUserToTalkgroup") == null) {
                        clearInterval(timer);
                        self.closeLoadingScreen();
                        self.updateTalkgroupUsers(input);
                    }
                }
            ,100);
        },
        updateTalkgroupUsers(input) {
            let operations = [];
            let remoteUser = false;

            // create addtotalkgroup request parameter
            for (let key in input.addTagList) {
                let tag = input.addTagList[key]
                operations.push({
                     command: "addtotalkgroup",
                     operation: {
                         tenantId: this.appData.tenantList[0].tenantId,
                         talkgroupId: this.talkgroupAttribute.id,
                         userTenantId: tag.tenantId,
                         userId: tag.userId
                     }
                });
            }

            // create removefromtalkgroup request parameter
            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key]
                operations.push({
                    command: "removefromtalkgroup",
                    operation: {
                        tenantId: this.appData.tenantList[0].tenantId,
                        talkgroupId: this.talkgroupAttribute.id,
                        userTenantId: tag.tenantId,
                        userId: tag.userId
                    }
                });
            }

            let self = this;

            if (operations.length == 0) {
                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_changing_information"));
                return;
            }
            server.post('/multiop', {operations: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getUserTalkgroupInfo({type: "Success", text:commonUtil.getMessageText(self.$i18n,"info_modified_participated_user_of_group")});
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            if (remoteUser) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_remove_userGroup_of_other_tenant"));
                            } else {
                                if (res.data.errorInfo.length > 0 && res.data.errorInfo[0].errorCode === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_in_alert_group_for_exceed"));
                                    break;
                                }
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_remove_userGroup_access_denied"));
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","updateTalkgroupUsers").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "updateTalkgroupUsers", error);
                });
        },
        insertNewTalkgroupToTree(insertData , parentNode) {
            if (parentNode.childNodes.length == 0) {
                parentNode.insertChild(insertData,0)
                parentNode.expand();
                return;
            }

            var insertIndex = this.getInsertIndexOfTalkgroup(parentNode , insertData.data.label);
            if (insertIndex < 0) {
                parentNode.insertBefore(insertData,parentNode.childNodes[0]);
            } else {
                parentNode.insertAfter(insertData,parentNode.childNodes[insertIndex]);
            }
        },
        findNode(rootNode , nodeId) {
            let foundNode = null;
            if (nodeId == 1) {
                return rootNode;
            }
            for (let node of rootNode.childNodes) {
                if (node.data.id == nodeId) {
                    return node;
                }
                if (node.childNodes.length > 0) {
                    let foundNode = this.findNode(node , nodeId)
                    if (foundNode != null) {
                        return foundNode;
                    }
                }
            }
            return;
        },
        getInsertIndexOfTalkgroup: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            let nodeLastIndex = -1;
            let userLastIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    nodeLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 1) {
                    userLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 2) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            if (insertIndex == -1) {
                if (userLastIndex >= 0) {
                    insertIndex = userLastIndex;
                } else if (nodeLastIndex >= 0) {
                    insertIndex = nodeLastIndex;
                }
            }
            return insertIndex;
        },
        findUser: function() {
            this.talkgroupUsers = [];
            let param = { talkgroupTenantId: this.appData.tenantList[0].tenantId, id: this.talkgroupAttribute.id }
            if (this.condition == "name") {
                if (this.searchString != "") {
                    param.searchName = this.searchString;
                }
            } else if (this.condition == "displayName") {
                if (this.searchString != "") {
                    param.searchDisplayName = this.searchString;
                }
            } else if (this.condition == "organization") {
                if (this.searchString != "") {
                    param.searchOrganization = this.searchString;
                }
            } else if (this.condition == "title") {
                if (this.searchString != "") {
                    param.searchTitle = this.searchString;
                }
            } else if (this.condition == "mandatoryYes") {
                param.searchMandatory = true;
            } else if (this.condition == "mandatoryNo") {
                param.searchMandatory = false;
            } else {
                if (this.condition == "all") {
                    this.searchString = "";
                    this.getUserTalkgroupInfo(null);
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_search_condition_not_found"));
                    return;
                }
            }

            this.showLoadingScreen();
            let self = this;
            server.post('/getusertalkgroupinfo', param)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.$data.talkgroupUsersExceededMax = false;
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            self.$data.talkgroupUsersExceededMax = true;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findUser").replace("{code}",res.data.status));
                            self.closeLoadingScreen();
                            return;
                    }
                    self.userCount = res.data.userCount;
                    self.mandatoryUserCount = res.data.mandatoryUserCount;
                    if (res.data.userTalkgroup.length == 0) {
                        commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_user_not_found"));
                        self.closeLoadingScreen();
                        return;
                    }
                    self.talkgroupUsers = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_USER).sortedUserTalkGroup;
                    self.closeLoadingScreen();
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "findUser", error);
                });
        },
        resetFindUser: function() {
            this.searchString = "";
            this.findUser();
        },
        handleChangeMandatory(talkgroupUser) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }

            if (this.talkgroupAttribute.talkgroupOptions.disconnectAlert) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_mandatory_group_on_alert_group"));
                return;
            }

            this.showLoadingScreen();
            let operations = [];
            let newFlag = 1;
            if (talkgroupUser.mandatoryFlag) {
                newFlag = 0;
            }
            let param = {
                           tenantId: talkgroupUser.tenantId,
                           talkgroupId: this.talkgroupAttribute.id,
                           userTenantId: talkgroupUser.userTenantId,
                           userName: talkgroupUser.userName,
                           newFlag: newFlag
                       }
            this.showLoadingScreen();
            let self = this;
            server.post('/setmandatorygroupuser', { operation: param }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (self.condition == "all") {
                            self.getUserTalkgroupInfo({type: "Success", text: commonUtil.getMessageText(self.$i18n,"info_mandatory_changed")});
                        } else {
                            self.findUser();
                        }
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MANDATORY_LIMIT:
                        if (self.condition == "all") {
                            self.getUserTalkgroupInfo({type: "Warning", text: commonUtil.getMessageText(self.$i18n,"error_mandatory_group_exceeded")});
                        } else {
                            self.findUser();
                        }
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_mandatory_access_denied").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                        break;
                    default:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleChangeMandatory2").replace("{code}",res.data.status));
                        break;
                }
                return;
            })
            .catch( function ( error ) {
                self.closeLoadingScreen();
                commonUtil.putExceptionErrorMessage(self, "handleMandatoryChange", error);
            });
        },
        handleChangeMandatoryOfGroup() {
            this.showLoadingScreen();
            let newFlag;
            if (this.mandatoryFlag) {
                newFlag = 1;
            } else {
                newFlag = 0;
            }
            let self = this;
            server.post('/setmandatorygroup', { operation: {
                                                         id: this.talkgroupAttribute.id,
                                                         newFlag: newFlag
                                                    }
                                                 }
            ).then((res) => {
                let errorMsg;
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (self.condition == "all") {
                            self.getUserTalkgroupInfo({type: "Success",text: commonUtil.getMessageText(self.$i18n,"info_mandatory_changed")});
                        } else {
                            self.findUser();
                        }
                        break;
                    case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                        let messageText;
                        if (newFlag == 1) {
                            messageText = commonUtil.getMessageText(self.$i18n,"error_mandatory_group_on");
                        } else {
                            messageText = commonUtil.getMessageText(self.$i18n,"error_mandatory_group_off");
                        }
                        if (self.condition == "all") {
                            self.getUserTalkgroupInfo({type: "Warning",text: messageText});
                        } else {
                            self.findUser();
                        }
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_mandatory_access_denied").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                        self.mandatoryFlag = !self.mandatoryFlag
                        self.closeLoadingScreen();
                        break;
                    case constants.STATUS_ERROR_OPTION_UNMATCH:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_mandatory_group_on_alert_group").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                        self.mandatoryFlag = !self.mandatoryFlag
                        self.closeLoadingScreen();
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleChangeMandatoryOfGroup").replace("{code}",res.data.status));
                        self.mandatoryFlag = !self.mandatoryFlag
                        self.closeLoadingScreen();
                        break;
                }

                return;
            })
            .catch( function ( error ) {
                self.closeLoadingScreen();
                commonUtil.putExceptionErrorMessage(self, "handleChangeMandatoryOfGroup", error);
            });
        },
        handleChangeSearchCondition() {
            if ((this.condition == "mandatoryYes") || ((this.condition == "mandatoryNo"))) {
                this.findUser();
            }
            if (this.condition == "all") {
                this.searchString = "";
                this.getUserTalkgroupInfo(null);
            }
        },
        handleChangeTab() {
            switch(this.selectedTabName) {
                case "userGroup":
                    this.getUserTalkgroupInfo(null);
                    break;
                case "subGroup":
                    if (this.talkgroupUsers.length == 0) {
                        this.getUserTalkgroupInfo(null);
                    }
                    break;
                default:
                    break;
            }
            this.reDrawTab();
        },
        beforeLeave(activeName, oldActiveName) {
            if (activeName == "userGroup") {
                this.showLoadingScreen();
            }
            return true;
        },
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = Loading.service({
                        lock: true ,
                        text: 'Loading data ...' ,
                        spinner: 'el-icon-loading' ,
                        background: 'rgba(0, 0, 0, 0)'
                });
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        isMandatorySwitchDisable() {
            if (this.appData.csvProcessing) {
                return true;
            }

            if (this.talkgroupAttribute.talkgroupOptions.disconnectAlert) {
                return true;
            }

            return false;
        },
        reDrawTab() {
            // some of message of old tab was remained in new tab.
            // it can clear by redraw
            this.showTab = false;
            this.$nextTick(() => {
                 this.showTab = true;
            });
        },
        getSpeechToTextEngineName(engineType) {
            let engineList = commonUtil.getSpeechToTextEngineList(this.$i18n);
            // add AmiVoice , Watson manually until official support.
            engineList.push({type: 5 ,displayName: "Watson Speech to Text"})

            for (let engine of engineList) {
                if (engine.type == engineType) {
                    return engine.displayName;
                }
            }
            return null;
        },
        getTranslationEngineName(engineType) {
            let engineList = commonUtil.getTranslationEngineList(this.$i18n);

            for (let engine of engineList) {
                if (engine.type == engineType) {
                    return engine.displayName;
                }
            }
            return null;
        },
        getTargetSubGroupName(subGroup) {
            let targetSubGroupList = "";
            if (subGroup.targetSubGroupIdList.length > 0) {
                for (let targetSubGroupId of subGroup.targetSubGroupIdList) {
                    let targetDisplayName = this.talkgroupAttribute.subGroups[targetSubGroupId - 1].displayName;
                    if ((targetSubGroupList.length + targetDisplayName.length) > 70) {
                        targetSubGroupList += "...";
                        break;
                    }
                    if (targetSubGroupList.length > 0) {
                        targetSubGroupList += " , ";
                    }
                    targetSubGroupList += targetDisplayName;
                }
            }
            return targetSubGroupList;
        },
        getJoinedSubGroupName(userTalkGroup) {
            let joinedSubGroupList = "";
            if (userTalkGroup.joinedSubGroupIdList.length > 0) {
                for (let subGroupId of userTalkGroup.joinedSubGroupIdList) {
                    let joinSubGroupName = this.talkgroupAttribute.subGroups[subGroupId - 1].displayName;
                    if ((joinedSubGroupList.length + joinSubGroupName.length) > 40) {
                        joinedSubGroupList += "...";
                        break;
                    }
                    if (joinedSubGroupList.length > 0) {
                        joinedSubGroupList += " , ";
                    }
                    joinedSubGroupList += joinSubGroupName;
                }
            }
            return joinedSubGroupList;
        },
        getUsersOfTargetSubGroup(subGroup) {
            let userList = "";
            if (subGroup.subGroupId in this.joinedUsersOfSubGroup) {
                let userInfoList = this.joinedUsersOfSubGroup[subGroup.subGroupId];
                for (let userInfo of userInfoList) {
                    if (userList != "") {
                        userList += " , ";
                    }
                    userList += userInfo.displayName;
                }
            }
            return userList;
        },
        setJoinedUsersOfSubGroup(userTalkGroupList) {
            this.joinedUsersOfSubGroup = {} ;
            for(let userTalkGroup of userTalkGroupList) {
                if (userTalkGroup.joinedSubGroupIdList.length > 0) {
                    for (let joinedSubGroup of userTalkGroup.joinedSubGroupIdList) {
                        let joinedUserInfo = {
                            subGroupId: joinedSubGroup,
                            tenantId: userTalkGroup.userTenantId,
                            tenantName: this.appData.tenantList[0].name,
                            userId: userTalkGroup.userId,
                            userName: userTalkGroup.userName,
                            displayName: userTalkGroup.displayName
                        };
                        if (joinedSubGroup in this.joinedUsersOfSubGroup) {
                            this.joinedUsersOfSubGroup[joinedSubGroup].push(joinedUserInfo)
                        } else {
                            Vue.set(this.joinedUsersOfSubGroup, joinedSubGroup, [ joinedUserInfo ]);
                        }
                    }
                }
            }
        },
        showManual() {
            this.showEditTalkgroup = false;
            this.appData.selectedMenu = "manual";
            this.$router.push({path: "/manual" , query: {item: "externalService"}})
        },
        isVisibleGroupOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleGroupOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        },
        getProcessorDefinitionById(processorDefinitionId) {
            for (let processorDefinition of this.$root.store.processorDefinitionList) {
                if (processorDefinition.id == processorDefinitionId) {
                    return processorDefinition;
                }
            }
            return null;
        },
        confirmRemoveAiAssignment(processorDefinitionId) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            this.removeProcessorDefinitionId = processorDefinitionId;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_groupAi");
            this.confirmInfo.objectName = this.getProcessorDefinitionById(processorDefinitionId).displayName;
            this.showConfirmDeleteAi = true;
        },
        getNumberOfAppsWithoutStorage() {
            let counter = 0;
            for (let processorDefinition of this.$root.store.processorDefinitionList) {
                if (processorDefinition.serviceId != constants.VAULT_SERVICE_STORAGE) {
                    counter++;
                }
            }
            return counter;
        },
        getMessageText(messageKey) {
            return commonUtil.getMessageText(this.$i18n, messageKey);
        },
    },
    created: function() {
        this.condition = "all";
        this.selectedTabName = "groupInfo";
        this.subGroupInfoList = commonUtil.getSubGroupInfoTypeList(this.$i18n);
        this.subGroupInfoType = constants.SUB_GROUP_INFO_DESTINATIONS;
//        this.setTalkgroupOptions(this.appData.onlinePurchase);
        return this.getInfo();
    },
    computed: {
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                if ((this.appData.enableSpeechTextOption) || (this.appData.enableSpeechTextTrial)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        shortEasyLoginURL: function() {
            return this.talkgroupAttribute.easyLoginURL.substring(0,50) + "...";
        },
        getTalkTypeName () {
            if (this.talkgroupAttribute.talkgroupOptions.interrupt) {
                return commonUtil.getMessageText(this.$i18n,"item_option_interrupt");
            } else if (this.talkgroupAttribute.talkgroupOptions.multi) {
                return commonUtil.getMessageText(this.$i18n,"item_option_fullDuplexCall");
            } else {
                return commonUtil.getMessageText(this.$i18n,"item_option_simplex");
            }
        },
        getEasyLoginTitle: function() {
            switch (this.talkgroupAttribute.talkgroupOptions.easyLogin) {
                case constants.EASY_LOGIN_TYPE_RANDOM:
                    return this.getMessageText('item_option_show_easyLogin_random');
                case constants.EASY_LOGIN_TYPE_SELECTION:
                    return this.getMessageText('item_option_show_easyLogin_selection');
                default:
                    return '';
            }
        },
        getEasyLoginHint: function() {
            switch (this.talkgroupAttribute.talkgroupOptions.easyLogin) {
                case constants.EASY_LOGIN_TYPE_RANDOM:
                    return this.getMessageText('hint_easy_login_random');
                case constants.EASY_LOGIN_TYPE_SELECTION:
                    return this.getMessageText('hint_easy_login_selection');
                default:
                    return '';
            }
        },
        needEasyLoginSelectionWarning: function() {
            return (this.talkgroupAttribute.talkgroupOptions.easyLogin == constants.EASY_LOGIN_TYPE_SELECTION);
        },
        showErrorInfo: function() {
            return this.talkGroupAttribute !== null || this.talkGroupAttribute.talkGroupOptions.disconnectAlert 
                ? commonUtil.getMessageText(this.$i18n,"error_mandatory_group_on_alert_group")
                : commonUtil.getMessageText(this.$i18n,"error_import_processing"); 
        }
    },
    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                if ((this.appData.importedTenantList.length > 0) || (this.appData.exportedTenantList.length > 0)) {
                    this.getConnectedTenantList();
                } else {
//                    this.setTalkgroupOptions(this.appData.onlinePurchase);
                    this.getInfo();
                }
                if (this.selectedTabName = "userGroup") {
                    this.selectedTabName = "groupInfo";
                    this.reDrawTab();
                }
            }
        },
        'appData.onlinePurchase'(newVal) {
//            this.setTalkgroupOptions(newVal);
            this.getInfo();
        },
        '$route' (to, from) {
            if (to.name == "User") {
                if ((this.appData.importedTenantList.length > 0) || (this.appData.exportedTenantList.length > 0)) {
                    this.getConnectedTenantList();
                }
            }
        }
    },
    props: ['selectedNode', 'appData', 'importedTenantList', 'listType' ]
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  list-style:none;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}
.modal-default-button {
  float: right;
}
.icon-delete {
    height: 20px;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.object-titlebox-red {
    width: 100%;
    background-color: #d55169;
    display: table;
    opacity: 0.3
}
.defaulttalkgroup {
    opacity: 0.6;
    font-size: 12px;
}
.talkgroup-user-record {
    border-bottom:1px #eee solid;
}
.talkgroup-user-record:hover {
    background-color: #ecf1fa;
}
.talkgroup-user-title {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.talkgroup-user-header1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.talkgroup-user-header2 {
    width: 15%;
    text-align:center;
}

.custom-checkbox-input {
  display: none;
}

.action-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}
.el-tabs__nav-scroll {
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}

.talkgroup-user-header1 >>> .el-select .el-input {
    font-size: 12px;
    width: 200px;
}
.talkgroup-user-header1 >>> .el-input__inner {
    height: 30px;
}
.talkgroup-user-header1 >>> .el-input__icon {
    line-height: 30px;
}

</style>
